/* Optional guided navigation; all editor tools remain freely accessible. */
(() => {
  class StudioSteps {
    constructor(ui) {
      this.ui = ui;
      this.steps = [['model','Modelis'],['background','Fonas'],['stickers','Lipdukai'],['text','Tekstas']];
      this.chosen = false;
      this.nav = ui.create('nav','sz-steps',`<div class="sz-step-tabs">${this.steps.map(([key,label],i)=>`<button type="button" data-studio-tool="${key}" data-design-step="${key}"><span>${i+1}</span>${label}</button>`).join('')}</div><div class="sz-step-progress"><span data-step-progress></span><button type="button" data-step-next></button></div>`);
      this.nav.setAttribute('aria-label','Dizaino kūrimo žingsniai');
      ui.root.querySelector('.sz-header').after(this.nav);
      this.panel = ui.create('section','sz-model-step', '<h2>Pasirink telefono modelį</h2><p>Pasirink modelį ir dėkliuko tipą, tada pereik prie lipdukų.</p><label>Telefono modelis<select data-step-model aria-label="Pasirink telefono modelį"></select></label><fieldset class="sz-case-types"><legend>Dėkliuko tipas</legend><label><input type="radio" name="studio-case-type" value="Skaidrus" checked><span>Skaidrus<small>24,99 €</small></span></label><label><input type="radio" name="studio-case-type" value="Skaidrus Magnetinis / MagSafe"><span>Skaidrus Magnetinis / MagSafe<small>29,99 €</small></span></label></fieldset><p data-case-price aria-live="polite"></p><p class="sz-step-note">Modelį ir dėkliuko tipą galėsi pakeisti ir vėliau.</p>');
      ui.sidebar.append(this.panel);
      this.continueButton = ui.create('button', 'sz-model-continue', 'Toliau: lipdukai →');
      this.continueButton.type = 'button';
      this.continueButton.disabled = true;
      this.panel.querySelector('[data-case-price]').after(this.continueButton);
      this.continueButton.addEventListener('click', () => {
        if (this.chosen) ui.openTool('stickers');
      });
      this.select = this.panel.querySelector('select');
      this.select.innerHTML = '<option value="" disabled selected>Pasirink modelį…</option>' + ui.root.querySelector('[data-model-select]').innerHTML;
      this.select.value = '';
      const modelField = ui.root.querySelector('.sidebar-model-field');
      modelField.hidden = true;
      modelField.classList.add('sz-native-model-field');
      this.modelButton = ui.create('button', 'sidebar-model-field sz-change-model', '<strong data-current-model></strong><span>Keisti modelį / tipą</span>');
      this.modelButton.type = 'button';
      this.modelButton.dataset.studioTool = 'model';
      this.modelButton.setAttribute('aria-label', 'Keisti telefono modelį ir dėkliuko tipą');
      modelField.after(this.modelButton);
      this.caseType = 'Skaidrus';
      ui.root.dataset.caseType = this.caseType;
      this.panel.querySelectorAll('[name="studio-case-type"]').forEach(input => input.addEventListener('change', () => {
        this.caseType = input.value;
        ui.root.dataset.caseType = this.caseType;
        this.sync();
      }));
      this.select.addEventListener('change',()=>{
        if (!this.select.value) return;
        this.chosen = true;
        const native = ui.studio.nodes.modelSelect;
        native.value = this.select.value;
        native.dispatchEvent(new Event('change',{bubbles:true}));
        this.sync();
      });
      ui.root.querySelector('[data-model-select]').addEventListener('change',()=>{
        this.chosen = true;
        if (ui.tool !== 'model') ui.openTool('model');
        else this.sync();
      });
      this.nav.querySelector('[data-step-next]').addEventListener('click',()=>{
        const index = this.steps.findIndex(([key])=>key===ui.tool);
        if (index>=0 && index<3 && (index!==0 || this.chosen)) ui.openTool(this.steps[index+1][0]);
      });
      queueMicrotask(()=>ui.openTool('model'));
    }
    sync() {
      const current = this.steps.findIndex(([key])=>key===this.ui.tool);
      this.modelButton.querySelector('[data-current-model]').textContent = this.ui.studio.model;
      this.modelButton.setAttribute('aria-expanded', String(this.ui.tool === 'model' && this.ui.sheetOpen));
      this.panel.hidden = this.ui.tool !== 'model';
      if (this.chosen) this.select.value = this.ui.studio.model;
      this.continueButton.disabled = !this.chosen;
      this.panel.querySelector('[data-case-price]').textContent = 'Kaina: ' + (this.caseType === 'Skaidrus' ? '24,99 €' : '29,99 €');
      this.nav.querySelectorAll('[data-design-step]').forEach(button=>{
        if(button.dataset.designStep===this.ui.tool) button.setAttribute('aria-current','step');
        else button.removeAttribute('aria-current');
      });
      this.nav.querySelector('[data-step-progress]').textContent = current>=0 ? `${current+1} iš 4` : '';
      const next=this.nav.querySelector('[data-step-next]');
      next.hidden=current<0 || current===3;
      next.disabled=current===0 && !this.chosen;
      next.textContent=current>=0 && current<3 ? `Toliau: ${this.steps[current+1][1]} →` : '';
    }
  }
  window.StrayzyStudioSteps=StudioSteps;
})();
